<template>
  <b-modal ref="modalEditionEffectifs" size="xxl" :title="'Lieu de consommation : ' + titre" scrollable
    no-close-on-backdrop
    @show="initialiser()">
    <template slot="default">
      <div class="container-fluid">
        <BarreFiltres :filtres="filtres" @appliquer-filtre="appliquerFiltre($event)" />

        <!----------------------->
        <div class="row">
          <div class="col-12" ref="effectifs">
            <!-- <div v-for="(typeConvive, iTypeConvive) in effectifsEnCours" :key="iTypeConvive" :id="'typeConvive' + iTypeConvive"> -->
              <div class="card table-scroll height-responsive-mod-1b">
                <!-- <div class="card-header">
                  Effectifs
                </div> -->
                <table class="table table-bordered table-sm text-center table-header">
                  <colgroup>
                    <col v-if="optionsLieuxConsommation && optionsLieuxConsommation.length">  <!-- Lieu de consommation -->
                    <col width="170"> <!-- Type de convive -->
                    <col v-if="optionsStructuresMenus && optionsStructuresMenus.length">      <!-- Structure de menu -->
                    <col width="130"> <!-- Service -->
                    <col width="150"> <!-- Composante -->
                    <col width="140"> <!-- Régime -->
                    <col width="100"> <!-- Texture -->
                    <col v-if="joursConsommation.find(j => j === 1)" width="60">  <!-- Effectifs du lundi -->
                    <col v-if="joursConsommation.find(j => j === 2)" width="60">  <!-- Effectifs du mardi -->
                    <col v-if="joursConsommation.find(j => j === 3)" width="60">  <!-- Effectifs du mercredi -->
                    <col v-if="joursConsommation.find(j => j === 4)" width="60">  <!-- Effectifs du jeudi -->
                    <col v-if="joursConsommation.find(j => j === 5)" width="60">  <!-- Effectifs du vendredi -->
                    <col v-if="joursConsommation.find(j => j === 6)" width="60">  <!-- Effectifs du samedi -->
                    <col v-if="joursConsommation.find(j => j === 0)" width="60">  <!-- Effectifs du dimanche -->
                    <col width="45">
                  </colgroup>
                  <thead>
                    <th v-if="optionsLieuxConsommation && optionsLieuxConsommation.length">Lieu de consommation</th>
                    <th>Type de convive</th>
                    <th v-if="optionsStructuresMenus && optionsStructuresMenus.length">Structure de menu</th>
                    <th>Service</th>
                    <th>Composante</th>
                    <th>Régime</th>
                    <th>Texture</th>
                    <th v-if="joursConsommation.find(j => j === 1)" >Lun.</th>
                    <th v-if="joursConsommation.find(j => j === 2)" >Mar.</th>
                    <th v-if="joursConsommation.find(j => j === 3)" >Mer.</th>
                    <th v-if="joursConsommation.find(j => j === 4)" >Jeu.</th>
                    <th v-if="joursConsommation.find(j => j === 5)" >Ven.</th>
                    <th v-if="joursConsommation.find(j => j === 6)" >Sam.</th>
                    <th v-if="joursConsommation.find(j => j === 0)" >Dim.</th>
                    <th></th>
                  </thead>
                </table>
                <div class="table-body">
                  <table class="table table-bordered table-sm text-center">
                    <colgroup>
                      <col v-if="optionsLieuxConsommation && optionsLieuxConsommation.length">  <!-- Lieu de consommation -->
                      <col width="170"> <!-- Type de convive -->
                      <col v-if="optionsStructuresMenus && optionsStructuresMenus.length">      <!-- Structure de menu -->
                      <col width="130"> <!-- Service -->
                      <col width="150"> <!-- Composante -->
                      <col width="140"> <!-- Régime -->
                      <col width="100"> <!-- Texture -->
                      <col v-if="joursConsommation.find(j => j === 1)"  width="60">  <!-- Effectifs du lundi -->
                      <col v-if="joursConsommation.find(j => j === 2)"  width="60">  <!-- Effectifs du mardi -->
                      <col v-if="joursConsommation.find(j => j === 3)"  width="60">  <!-- Effectifs du mercredi -->
                      <col v-if="joursConsommation.find(j => j === 4)"  width="60">  <!-- Effectifs du jeudi -->
                      <col v-if="joursConsommation.find(j => j === 5)"  width="60">  <!-- Effectifs du vendredi -->
                      <col v-if="joursConsommation.find(j => j === 6)"  width="60">  <!-- Effectifs du samedi -->
                      <col v-if="joursConsommation.find(j => j === 0)"  width="60">  <!-- Effectifs du dimanche -->
                      <col width="40">
                    </colgroup>
                    <tbody>
                      <template v-for="(effectif, iEffectif) in effectifsEnCoursFiltres">
                        <tr :key="'service'+iEffectif">
                          <td v-if="optionsLieuxConsommation && optionsLieuxConsommation.length" class="aligner-gauche">
                            {{ effectif.nomLieuConsommation }}
                          </td>
                          <td class="aligner-gauche">
                            {{ effectif.nomTypeConvive }}
                          </td>
                          <td v-if="optionsStructuresMenus && optionsStructuresMenus.length" class="aligner-gauche">
                            {{ effectif.nomStructureMenu }}
                          </td>
                          <td class="aligner-gauche">
                            {{ effectif.nomTypeService }}
                          </td>
                          <td class="aligner-gauche">
                            {{ effectif.nomStructureMenuComposante }}
                          </td>
                          <td class="aligner-gauche">
                            {{ abregerTexte(effectif.nomTypeRegime, 25) }}
                          </td>
                          <td class="aligner-gauche">
                            {{ effectif.nomTypeTexture }}
                          </td>
                          <td v-if="joursConsommation.find(j => j === 1)" class="input">
                            <InputNumber v-model="effectif.effectifsLundi" typeFiltre="quantiteEntiere" />
                          </td>
                          <td v-if="joursConsommation.find(j => j === 2)" class="input">
                            <InputNumber v-model="effectif.effectifsMardi" typeFiltre="quantiteEntiere" />
                          </td>
                          <td v-if="joursConsommation.find(j => j === 3)" class="input">
                            <InputNumber v-model="effectif.effectifsMercredi" typeFiltre="quantiteEntiere" />
                          </td>
                          <td v-if="joursConsommation.find(j => j === 4)" class="input">
                            <InputNumber v-model="effectif.effectifsJeudi" typeFiltre="quantiteEntiere" />
                          </td>
                          <td v-if="joursConsommation.find(j => j === 5)" class="input">
                            <InputNumber v-model="effectif.effectifsVendredi" typeFiltre="quantiteEntiere" />
                          </td>
                          <td v-if="joursConsommation.find(j => j === 6)" class="input">
                            <InputNumber v-model="effectif.effectifsSamedi" typeFiltre="quantiteEntiere" />
                          </td>
                          <td v-if="joursConsommation.find(j => j === 0)" class="input">
                            <InputNumber v-model="effectif.effectifsDimache" typeFiltre="quantiteEntiere" />
                          </td>
                          <td>
                            <!-- <button type="button" class="btn btn-primary btn-sm-large" @click="copierEffectifsSemaine(effectif)">
                              <i class="fas fa-copy"></i>
                              <i class="fas fa-arrow-right"></i>
                            </button> -->
                            <button type="button" class="btn btn-danger btn-sm" @click="copierEffectifsSemaine(effectif)">
                              <i class="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            <!-- </div> -->
          </div>
        </div>
        <!----------------------->






                <!-- Historique -->
                <!-- <div class="card-body">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-5 flex-center-space-between">
                        <div style="align-self:start;margin-top:10px;">
                          <b-button class="btn-sm btn-secondary" @click="alertModal(typeService.value)"><i class="fas fa-plus"></i> composante</b-button>
                        </div>
                        <div style="align-self:flex-end;margin-bottom:30px;">Eff.</div>
                      </div>
                      <div class="col-7">
                        <div class="container-fluid">
                          <div class="row">
                            <div class="col-11">
                              <table class="table" style="table-layout:fixed;word-wrap:break-word;">
                                <thead>
                                  <tr>
                                    <th v-for="jour in optionsJours" style="font-size:.7rem;padding-left:12px;" :key="jour.nom">
                                      <button type="button" class="btn btn-secondary btn-changer-eff" v-b-modal="'changerEffectif-' + typeService.value + '-' + jour.id">{{ jour.nomCourt }}&nbsp;<i class="fas fa-users cursor-pointer"></i></button>
                                      <b-modal :id="'changerEffectif-' + typeService.value + '-' + jour.id" hide-footer header-bg-variant="success" header-text-variant="light" @show="initEffectifsJour(typeService.value, jour.id)">
                                        <template slot="modal-title">
                                          <h3><i class="fas fa-users" style="margin-right:1rem"></i>Effectifs {{ typeService.text.toLocaleLowerCase() }}, {{ jour.nom.toLocaleLowerCase() }}</h3>
                                        </template>
                                        <template slot="default">
                                          <div class="container-fluid" :key="keyEffectifsJour">
                                            <div class="row">
                                              <div class="col-6">Régime / Texture</div>
                                              <div class="col-3">Effectif</div>
                                            </div>
                                            <div v-for="(type, iType) in effectifsJour" :key="iType" class="row" style="margin-top:10px;">
                                              <div class="col-6">{{ type.titre }}</div>
                                              <div class="col-3"><InputNumber v-model="type.effectif" typeFiltre="quantiteEntiere" /></div>
                                            </div>
                                          </div>
                                          <div style="margin: 2rem 0; text-align:right">
                                            <button class="btn btn-primary" style="background: #d33 !important;border-color: #d33 !important;" @click="setEffectifsJour(typeService.value, jour.id)">
                                              Valider</button>
                                            <button class="btn btn-danger" style="margin-left:3rem; background: #3085d6 !important;border-color: #3085d6 !important;" @click="$bvModal.hide('changerEffectif-' + typeService.value + '-' + jour.id)">Annuler</button>
                                          </div>
                                        </template>
                                      </b-modal>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td class="td-input-container" v-for="(service, iService) in planServices(typeService.value)" :key="iService">
                                      <InputNumber v-if="service" v-model="service.effectif" :key="service.serviceId + service.jour" typeFiltre="quantiteEntiere" :data-key="service.serviceId + '-' + service.jour" @move="moveEffectif($event, planServices(typeService.value), iService)" />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-5">
                        <table class="table" style="table-layout:fixed;word-wrap:break-word;">
                          <tbody>
                            <tr v-for="(service, iService) in planServices(typeService.value).slice(0, 1)" :key="iService">
                              <div v-if="service">
                                <td v-for="(composante, iComposante) in service.planComposantes" :key="iComposante" class="ligne-composante-titre">
                                  <div>
                                    {{ titreComposante(composante) }}
                                  </div>
                                  <div class="flex-center-space-between" v-if="!plan.gestionParPlan" style=";display: flex;align-items: flex-start;flex-direction: row">
                                    <div class="inline-dropdown" style="position:relative">
                                      <b-form-select v-if="composante.index !== 0" v-model="composante.regimeId" :options="optionsRegimes" @change="
                                        composanteRT($event, service.serviceId, composante.composanteId, composante.index,'regime' ) ">
                                        <template slot="first">
                                          <option :value="null" disabled>Régime...</option>
                                        </template>
                                      </b-form-select>
                                      <div class="error" style="position:absolute;top:3px" v-if="composante.regimeId === ''">
                                        * requis
                                      </div>
                                    </div>
                                    <div class="inline-dropdown">
                                      <b-form-select v-if="composante.index !== 0" v-model="composante.textureId" :options="optionsTextures" @change="composanteRT($event, service.serviceId, composante.composanteId, composante.index, 'texture')" style="margin-left:15px;margin-right:10px">
                                        <template slot="first">
                                          <option :value="null" disabled>Texture...</option>
                                        </template>
                                      </b-form-select>
                                    </div>
                                  </div>
                                  <div>Eff.</div>
                                </td>
                              </div>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="col-7">
                        <div class="container-fluid">
                          <div class="row">
                            <div class="col-11">
                              <table class="table" style="table-layout:fixed;word-wrap:break-word;">
                                <tbody>
                                  <tr>
                                    <td class="td-input-container" v-for="(service, iService) in planServices(typeService.value)" :key="iService">
                                      <div v-if="service" style="width:inherit">
                                        <div v-for="(composante, iComposante) in service.planComposantes" :key="iComposante" style="width:inherit" class="td-height">
                                          <InputNumber v-model="composante.effectif" :key="composante.composanteId + service.serviceId + service.jour" typeFiltre="quantiteEntiere" :data-key="service.serviceId + '-' + service.jour + '-' + composante.cleComposee" @move="moveEffectifComposante($event, planServices(typeService.value), iService, iComposante)" />
                                        </div>
                                      </div>
                                    </td>
                                  </tr> -->
                                  <!-- <tr>
                                    <td class="td-input-container" v-for="(service, iService) in planServices(typeService.value)" :key="iService">
                                      <div v-if="service && service.cleComposee" @click="dupliquerEffectifs(planServices(typeService.value), service)" v-tooltip="{content: 'Dupliquer les effectifs', placement: 'top'}" style="transform:translate(15px);">
                                        <i class="far fa-copy"></i>
                                      </div>
                                    </td>
                                  </tr> -->
                                <!-- </tbody>
                              </table>
                            </div>
                            <div class="col-1">
                              <table class="table">
                                <tbody>
                                  <tr v-for="(service, iService) in planServices(typeService.value).slice(0, 1)" :key="iService">
                                    <div v-if="service">
                                      <td class="flex-center-space-between cursor-pointer container-dupliquer-effacer" v-for="(composante, iComposante) in service.planComposantes" :key="iComposante">
                                        <button type="button" v-if="composante.index === 0" class="btn btn-sm btn-primary" @click="dupliquerComposante(typeService.value, composante.composanteId)" v-tooltip="{content: 'Dupliquer la composante', placement: 'top'}">
                                          <i class="far fa-copy"></i>
                                        </button>
                                        <div v-else style="width:15px"></div>
                                        <button type="button" class="btn btn-sm btn-danger" @click="effacerComposante(typeService.value, composante.composanteId, composante.index)" v-tooltip="{content: 'Supprimer la composante', placement: 'top'}">
                                          <i class="fas fa-times"></i>
                                        </button>
                                      </td>
                                    </div>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->
                <!-- Historique -->


      </div>
      <!-- <div class="error" v-if="toutEstNan" style="display:inline-block;">Veuillez saisir au moins un effectif pour cette structure de menu</div> -->
      <!-- <b-button v-if="this.planId" @click.prevent="supprimer(plan.id)"><i class="fas fa-times"></i></b-button> -->
    </template>
    <template slot="modal-footer">
      <div class="flex-center-space-between w-100">
        <div>
          <button type="button" class="btn btn-primary" @click="exporter(planId)">Exporter</button>
        </div>
        <div>
          <button type="button" class="btn btn-secondary mr-2" @click="hide()">Annuler</button>
          <button type="button" class="btn btn-primary" @click="modifierEffectifs(plan)">Valider</button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import BarreFiltres from '@/components/Divers/BarreFiltres'
import { mapActions } from "vuex"
import { constantesId } from "@/helpers/constantes"
import { required } from "vuelidate/lib/validators"
import { arrayEmpty } from "@/mixins/index"
import { supprimerMenuStructure, desactiverMenuStructure, obtenirMenuStructure, chargerStructures } from "@/api/gpao/menus"
import { obtenirBarquettes } from '@/api/gpao/production'
import { showAlerts } from "@/mixins/alerts"
import { optionsJours } from "@/mixins/menus"
import { connecteData } from "@/mixins/connecteData"
import { lancerTelechargement, abregerTexte } from "@/helpers/utils"
import InputNumber from "@/components/Inputs/InputNumber"
import _ from "lodash"

export default {
  mixins: [arrayEmpty, showAlerts, optionsJours, connecteData],
  components: { BarreFiltres, InputNumber },
  props: {
    titre: String,
    effectifs: Array,
    lieuxConsommation: Array,
    typesConvives: Array,
    structuresMenus: Array,
    typesServices: Array,
    typesRegimes: Array,
    typesTextures: Array
  },
  data() {
    return {
      effectifsEnCours: null,
      planId: undefined,
      montrerModalCreation: false,
      montrerModalEdition: false,
      plan: {
        nom: "",
        typeConviveId: null,
        utilisateurId: null,
        services: [],
        regimeId: "RE3", // 'normal' à vérifier avec la base en prod
        textureId: "TE1", // 'normal' idem
        gestionParPlan: true,
        etablissementId: null,
        excluEffectifPortage: false,
      },
      planRedacteurOriginal: null,
      //optionsServices: this.$store.state.definitions.services,
      optionsComposantesRepas: this.$store.state.definitions.composantesRepas,
      // optionsRegimes: this.$store.state.definitions.regimes,
      // optionsTextures: this.$store.state.definitions.textures,
      composantesSelectionnees: [],
      optionsGestionPar: [{ text: "Composantes", value: false }, { text: "Structure", value: true }],
      enEnregistrement: false,
      typeStructure: null,
      structures: null,
      structureACopier: null,
      facturablesEnLectureSeule: true,
      facturables: [],
      facturablesAvant: "",
      erreurFacturables: false,
      montrerFacturables: false,
      keyFacturables: 1,
      keyEffectifsJour: 1,
      effectifsJour: [],
      listeBarquettes: [],
      filtres: {
        lieuConsommation: {
          label: "Lieu de consommation",
          champ: "select",
          width: "325px",
          //disabled: true,
          options: [],
          selection: null,
          clearable: false,
          initialiser(contexte) {
            let filtre = contexte.filtres.lieuConsommation
            filtre.options = contexte.optionsLieuxConsommation
            //filtre.disabled = filtre.options.length < 2
            filtre.selection = filtre.options.length < 2 ? filtre.options.first() : null
            filtre.clearable = filtre.options.length > 1
          },
          async filtrer(contexte, valeur) {
            let filtre = contexte.filtres.lieuConsommation
            if (valeur) {
              filtre.selection = filtre.options?.find(o => o.valeur === valeur)
            }
          }
        },
        typeConvive: {
          label: "Type de convive",
          champ: "select",
          width: "240px",
          options: [],
          selection: null,
          clearable: false,
          initialiser(contexte) {
            let filtre = contexte.filtres.typeConvive
            filtre.options = contexte.optionsTypesConvives
            //filtre.disabled = filtre.options.length < 2
            filtre.selection = filtre.options.length < 2 ? filtre.options.first() : null
            filtre.clearable = filtre.options.length > 1
          },
          filtrer(contexte, valeur) {
            let filtre = contexte.filtres.typeConvive
            if (valeur) {
              filtre.selection = filtre.options?.find(o => o.valeur === valeur)
            }
          }
        },
        structure: {
          label: "Structure de menu",
          champ: "select",
          width: "300px",
          options: [],
          selection: null,
          clearable: false,
          initialiser(contexte) {
            let filtre = contexte.filtres.structure
            filtre.options = contexte.optionsStructuresMenus
            //filtre.disabled = filtre.options.length < 2
            filtre.selection = filtre.options.length < 2 ? filtre.options.first() : null
            filtre.clearable = filtre.options.length > 1
          },
          filtrer(contexte, valeur) {
            let filtre = contexte.filtres.structure
            if (valeur) {
              filtre.selection = filtre.options?.find(o => o.valeur === valeur)
            }
          }
        },
        service: {
          label: "Service",
          champ: "select",
          width: "190px",
          options: [],
          selection: null,
          clearable: false,
          initialiser(contexte) {
            let filtre = contexte.filtres.service
            filtre.options = contexte.optionsTypesServices
            //filtre.disabled = filtre.options.length < 2
            filtre.selection = filtre.options.length < 2 ? filtre.options.first() : null
            filtre.clearable = filtre.options.length > 1
          },
          filtrer(contexte, valeur) {
            let filtre = contexte.filtres.service
            if (valeur) {
              filtre.selection = filtre.options?.find(o => o.valeur === valeur)
            }
          }
        },
        composante: {
          label: "Composante",
          champ: "select",
          width: "190px",
          options: [],
          selection: null,
          clearable: false,
          // initialiser(contexte) {
          //   let filtre = contexte.filtres.service
          //   filtre.options = contexte.optionsServices?.map(s => ({ valeur: s.id, texte: s.nom })) || []
          //   filtre.selection = filtre.options?.find(s => s.valeur === contexte.filters.sel)
          //   filtre.clearable = filtre.options.length > 1
          // },
          filtrer(contexte, valeur) {
            let filtre = contexte.filtres.selections
            if (valeur) {
              filtre.selection = filtre.options?.find(s => s.valeur === valeur)
            }
            let selection = contexte.optionsSelections?.find(s => s.selectionId === contexte.filtres.selections.selection.valeur)
            if (selection) {
              contexte.onSelectSelection(selection)
            }
          }
        },
        regime: {
          label: "Régime",
          champ: "select",
          width: "210px",
          options: [],
          selection: null,
          clearable: false,
          initialiser(contexte) {
            let filtre = contexte.filtres.regime
            filtre.options = contexte.optionsTypesRegimes
            //filtre.disabled = filtre.options.length < 2
            filtre.selection = filtre.options.length < 2 ? filtre.options.first() : null
            filtre.clearable = filtre.options.length > 1
          },
          filtrer(contexte, valeur) {
            let filtre = contexte.filtres.regime
            if (valeur) {
              filtre.selection = filtre.options?.find(s => s.valeur === valeur)
            }
          }
        },
        texture: {
          label: "Texture",
          champ: "select",
          width: "140px",
          options: [],
          selection: null,
          clearable: false,
          initialiser(contexte) {
            let filtre = contexte.filtres.texture
            filtre.options = contexte.optionsTypesTextures
            //filtre.disabled = filtre.options.length < 2
            filtre.selection = filtre.options.length < 2 ? filtre.options.first() : null
            filtre.clearable = filtre.options.length > 1
          },
          filtrer(contexte, valeur) {
            let filtre = contexte.filtres.texture
            if (valeur) {
              filtre.selection = filtre.options?.find(s => s.valeur === valeur)
            }
          }
        },
        reinitialiser: {
          label: "Réinitialiser les filtres",
          champ: "btn",
          filtrer(contexte) {
            contexte.filtres.barreGauche.forEach(f => {
              if (f.initialiser) {
                f.initialiser(contexte)
              }
            })
          }
        },
        // Appeler "this.filtres.initialiser(this)" dans mounted() => génère le tableau de filtres utilisés pour afficher les filtres dans la barre de filtres
        barreGauche: [],
        barreDroite: [],
        async initialiser(contexte) {
          //contexte.filtres.barreGauche = [ contexte.filtres.lieuConsommation, contexte.filtres.typeConvive, contexte.filtres.structure, contexte.filtres.service/*, contexte.filtres.composante, contexte.filtres.regime, contexte.filtres.texture*/ ]
          //contexte.filtres.barreDroite = [ contexte.filtres.familles, contexte.filtres.selections, contexte.filtres.rechercheNom, contexte.filtres.favoris ]

          contexte.filtres.barreGauche = []
          if (contexte.optionsLieuxConsommation?.length) {
            contexte.filtres.barreGauche.push(contexte.filtres.lieuConsommation)
          }
          // if ((contexte.optionsTypesConvives?.length || 0) > 1) {
            contexte.filtres.barreGauche.push(contexte.filtres.typeConvive)
          // }
          if (contexte.optionsStructuresMenus?.length) {
            contexte.filtres.barreGauche.push(contexte.filtres.structure)
          }
          // if ((contexte.optionsTypesServices?.length || 0) > 1) {
            contexte.filtres.barreGauche.push(contexte.filtres.service)
          // }
          // if ((contexte.optionsTypesRegimes?.length || 0) > 1) {
            contexte.filtres.barreGauche.push(contexte.filtres.regime)
          // }
          // if ((contexte.optionsTypesTextures?.length || 0) > 1) {
            contexte.filtres.barreGauche.push(contexte.filtres.texture)
          // }

          // if ((contexte.optionsTypesComposantes?.length ||0) > 1) {
          //   contexte.filtres.barreGauche.push(contexte.filtres.composante)
          // }

          contexte.filtres.barreDroite = [ contexte.filtres.reinitialiser ]

          contexte.filtres.barreGauche.forEach(f => {
            if (f.initialiser) {
              f.initialiser(contexte)
            }
          })
          // if (!contexte.filtres.structure.options?.length) {
          //   contexte.filtres.barreGauche.splice(2, 1)
          // }
          // if (!contexte.filtres.lieuConsommation.options?.length) {
          //   contexte.filtres.barreGauche.splice(0, 1)
          // }
          // contexte.filtres.barreDroite.forEach(f => {
          //   if (f.initialiser) {
          //     f.initialiser(contexte)
          //   }
          // })
        }
      }
    }
  },
  validations: {
    plan: {
      nom: { required },
      typeConviveId: { required }
    }
  },
  watch: {
    typeStructure() {
      this.structureACopier = null
    },
    montrerFacturables(visible) {
      setTimeout(() => {
        if (visible) {
          window.addEventListener("click", this.clickOutFacturables)
        } else {
          window.removeEventListener("click", this.clickOutFacturables)
        }
      }, 10)
    }
  },
  computed: {
    // effectifsEnCours() {
    //   return this.effectifs?.flatMap(e => e.effectifs) || []
    // },
    effectifsEnCoursFiltres() {
      let eff = this.effectifsEnCours
      if (this.filtres.lieuConsommation?.selection?.valeur) {
        eff = eff.filter(e => e.lieuConsommationId === this.filtres.lieuConsommation.selection.valeur)
      }
      if (this.filtres.typeConvive?.selection?.valeur) {
        eff = eff.filter(e => e.typeConviveId === this.filtres.typeConvive.selection.valeur)
      }
      if (this.filtres.structure?.selection?.valeur) {
        eff = eff.filter(e => e.structureMenuId === this.filtres.structure.selection.valeur)
      }
      if (this.filtres.service?.selection?.valeur) {
        eff = eff.filter(e => e.typeServiceId === this.filtres.service.selection.valeur)
      }
      if (this.filtres.regime?.selection?.valeur) {
        eff = eff.filter(e => e.typeRegimeId === this.filtres.regime.selection.valeur)
      }
      if (this.filtres.texture?.selection?.valeur) {
        eff = eff.filter(e => e.typeTextureId === this.filtres.texture.selection.valeur)
      }
      return eff
    },
    optionsLieuxConsommation() {
      let lieuxIds = [...new Set(this.effectifsEnCours?.map(e => e.lieuConsommationId))]
      return this.lieuxConsommation?.filter(l => lieuxIds.some(li => l.id === li))?.map(l => ({ valeur: l.id, texte: l.nom })) || []
    },
    optionsTypesConvives() {
      let tcIds = [...new Set(this.effectifsEnCours?.map(e => e.typeConviveId))]
      return this.typesConvives?.filter(tc => tcIds.some(tci => tc.id === tci))?.map(tc => ({ valeur: tc.id, texte: tc.nom })) || []
    },
    optionsStructuresMenus() {
      let sIds = [...new Set(this.effectifsEnCours?.map(e => e.structureMenuId))]
      return this.structuresMenus?.filter(s => sIds.some(si => s.id === si))?.map(s => ({ valeur: s.id, texte: s.nom })) || []
    },
    optionsTypesServices() {
      let tsIds = [...new Set(this.effectifsEnCours?.map(e => e.typeServiceId))]
      return this.typesServices?.filter(ts => tsIds.some(tsi => ts.id === tsi))?.map(ts => ({ valeur: ts.id, texte: ts.nom })) || []
    },
    optionsTypesRegimes() {
      let trIds = [...new Set(this.effectifsEnCours?.map(e => e.typeRegimeId))]
      return this.typesRegimes?.filter(tr => trIds.some(tri => tr.id === tri))?.map(tr => ({ valeur: tr.id, texte: abregerTexte(tr.nom, 25) })) || []
    },
    optionsTypesTextures() {
      let ttIds = [...new Set(this.effectifsEnCours?.map(e => e.typeTextureId))]
      return this.typesTextures?.filter(tt => ttIds.some(tti => tt.id === tti))?.map(tt => ({ valeur: tt.id, texte: tt.nom })) || []
    },
    joursConsommation() {
      // Jours de consommation : permet d'adapter le contenu du tableau des effectifs en fonction des jours configurés
      return [...new Set(this.effectifsEnCours?.flatMap(e => e.joursConsommation))]
    },
    optionsConvives() {
      const convivesTypes = this.$store.state.definitions.convivesTypes && this.$store.state.definitions.convivesTypes.slice() || []
      return convivesTypes
    },
    peutEnregistrer() {
      return !this.$v.plan.nom.required || !this.$v.plan.typeConviveId.required || this.toutEstNan
    },
    estNeutre() {
      return this.plan.typeConviveId === constantesId.typeConviveIdNeutre
    },
    structureUniverselle() {
      return !this.plan.etablissementId;
    },
    toutEstNan() {
      for (let s = 0; s < this.plan.services.length; s++) {
        let service = this.plan.services[s]

        if (!Number.isNaN(service.effectif) && service.effectif != null) {
          return false
        }
        for (let c = 0; c < service.planComposantes.length; c++) {
          let composante = service.planComposantes[c]

          if (composante && !Number.isNaN(composante.effectif) && composante.effectif != null) {
            return false
          }
        }
      }
      return true;
    },
    creationOK() {
      return this.typeStructure === "nouvelle" || this.typeStructure === "universelle" || this.structureACopier
    },
    dataFacturables() {
      return this.facturables.map(f => {
        return {
          Id: f.Id,
          Libelle: f.Libelle
        }
      })
    },
    modifFacturables() {
      return this.facturablesAvant !== JSON.stringify(this.dataFacturables)
    }
  },
  methods: {
    ...mapActions("uxHelpers", ["afficherAttente", "cacherAttente"]),
    appliquerFiltre(filtrer) {
      // Nécessaire pour faire fonctionner les filtres de la barre de filtres
      filtrer(this)
    },
    executerAction(methode) {
      methode(this)
    },
   show() {
      this.$refs.modalEditionEffectifs.show()
    },
    hide() {
      this.$refs.modalEditionEffectifs.hide()
    },
    initialiser() {
      this.effectifsEnCours = _.cloneDeep(this.effectifs || [])

      this.filtres.initialiser(this)
    },
    abregerTexte(texte, longueur) {
      return abregerTexte(texte, longueur)
    },
    copierEffectifsSemaine(ligneEffectifs) {
      if ((ligneEffectifs.joursConsommation?.length || 0) < 2) {
        this.alerteInformation("Duplication impossible !", "Plusieurs jours de consommation sont nécessaires pour pouvoir copier les jours d'effectifs sur la semaine.")
      }
      // Lecture du 1er jour de consommation de la semaine
      let premJourConso = ligneEffectifs.joursConsommation?.filter(j => j > 0).sort().first()
      if (premJourConso) {
        let effectifsACopier = this.getEffectifsJour(ligneEffectifs, premJourConso)
        ligneEffectifs.joursConsommation.filter(j => j !== premJourConso).forEach(j => {
          this.setEffectifsJour(ligneEffectifs, j, effectifsACopier)
        })
      }
    },
    getEffectifsJour(ligneEffectifs, numJour) {
      switch (numJour) {
        case 1: // Lundi
          return ligneEffectifs.effectifsLundi
        case 2: // Mardi
          return ligneEffectifs.effectifsMardi
        case 3: // Mercredi
          return ligneEffectifs.effectifsMercredi
        case 4: // Jeudi
          return ligneEffectifs.effectifsJeudi
        case 5: // Vendredi
          return ligneEffectifs.effectifsVendredi
        case 6: // Samedi
          return ligneEffectifs.effectifsSamedi
        case 0: // Dimanche
          return ligneEffectifs.effectifsDimanche
        default:
          return null
      }
    },
    setEffectifsJour(ligneEffectifs, numJour, valeur) {
      switch (numJour) {
        case 1: // Lundi
          ligneEffectifs.effectifsLundi = valeur
          break
        case 2: // Mardi
          ligneEffectifs.effectifsMardi = valeur
          break
        case 3: // Mercredi
          ligneEffectifs.effectifsMercredi = valeur
          break
        case 4: // Jeudi
          ligneEffectifs.effectifsJeudi = valeur
          break
        case 5: // Vendredi
          ligneEffectifs.effectifsVendredi = valeur
          break
        case 6: // Samedi
          ligneEffectifs.effectifsSamedi = valeur
          break
        case 0: // Dimanche
          ligneEffectifs.effectifsDimanche = valeur
          break
        default:
          return false
      }
      return true
    },
    afficherModal(planId) {
      this.enEnregistrement = false
      this.montrerFacturables = false
      if (!planId) {//création
        this.typeStructure = null
        this.structureACopier = null
        this.structures = null
        this.planId = null
        this.montrerModalCreation = true
        return chargerStructures(this.etabCourantId)
          .then(r => this.structures = r.data || [])
      }
      this.planId = planId//édition
      this.montrerModalEdition = true

      


      this.initialiserFenetre()
    },
    creerStructure() {
      this.montrerModalCreation = false
      this.montrerModalEdition = true
      this.initialiserFenetre(this.structureACopier, this.typeStructure === "universelle")
    },
    async initialiserFenetre(aCopier, universelle) {
      this.plan.nom = undefined
      this.plan.typeConviveId = undefined
      this.plan.textureId = undefined
      this.plan.regimeId = undefined
      this.plan.menuStructureOrigineId = undefined

      //Chargement des barquettes possibles
      let ret = await obtenirBarquettes(this.etabCourantId)
      this.listeBarquettes = ret.data || []

      if (aCopier) {// copie
        await this.getPlanPourEdition(aCopier, universelle)
      } else if (this.planId) {// édition
        await this.getPlanPourEdition(this.planId)
      } else {// création
        this.plan.id = undefined
        this.plan.etablissementId = this.etabCourantId
        this.plan.services = []
        this.plan.gestionParPlan = false
        this.plan.estUniversel = universelle
        this.plan.barquettes = _.cloneDeep(this.listeBarquettes)
        this.creerServiceJours()
      }

      
    },
    setRegimesEtTexturesDesComposantes() {
      if (this.plan.gestionParPlan) {
        this.plan.regimeId = "RE3" // 'normal' à vérifier avec la base en prod
        this.plan.textureId = constantesId.textureNormale
        this.plan.services.map(service => {
          service.planComposantes.map(planCp => {
            planCp.regimeId = "RE3" // 'normal' à vérifier avec la base en prod
            planCp.textureId = constantesId.textureNormale
          })
        })
      }
    },
    setRegimeDesComposantes(event) {
      if (this.plan.gestionParPlan) {
        this.plan.services.map(service => {
          service.planComposantes.map(planCp => {
            planCp.regimeId = event.sender.value()
          })
        })
      }
    },
    setTextureDesComposantes(event) {
      if (this.plan.gestionParPlan) {
        this.plan.services.map(service => {
          service.planComposantes.map(planCp => {
            planCp.textureId = event.sender.value()
          })
        })
      }
    },
    async alertModal(serviceId) {
      let htmlComposante = ""
      let optionsComposantesRepas = null
      if (
        this.plan.services.find(service => service.serviceId === serviceId)
          .planComposantes.length === 0
      ) {
        optionsComposantesRepas = this.optionsComposantesRepas
      } else {
        let optionsDejaPresentes = this.plan.services
          .find(service => service.serviceId === serviceId)
          .planComposantes.map(planCp => {
            return this.optionsComposantesRepas.find(
              comp => comp.value === planCp.composanteId
            )
          })
        optionsComposantesRepas = _.difference(this.optionsComposantesRepas, optionsDejaPresentes)
      }
      optionsComposantesRepas.forEach(element => {
        htmlComposante += `<div style="text-align:left;margin-left:30%"><div class="custom-control custom-checkbox"><input type="checkbox" class="custom-control-input" name="${element.value}" value="${element.value}" id="${element.value}"><label for="${element.value}" class="custom-control-label">${element.text}</label></input></div></div>`
      })
      let checkboxIds = []
      optionsComposantesRepas.forEach(element => {
        checkboxIds.push(element.value)
      })
      const service = serviceId
      const { value: formValues } = await this.$swal.fire({
        title: "Ajouter des composantes",
        html: htmlComposante,
        focusConfirm: false,
        preConfirm: () => {
          return [
            checkboxIds.forEach(id => {
              if (document.getElementById(id).checked) {
                this.composantesSelectionnees.push(
                  document.getElementById(id).value
                )
              }
            })
          ]
        }
      })
      if (formValues) {
        this.ajouterComposante(service)
      }
    },
    composanteRT(event, serviceId, composanteId, index, categorie) {
      let id = event
      // eslint-disable-next-line promise/avoid-new
      return new Promise(resolve => {
        this.plan.services
          .filter(jourDeService => jourDeService.serviceId === serviceId)
          .map(service => {
            service.planComposantes.map(composante => {
              if (
                composante.index === index &&
                composante.composanteId === composanteId
              ) {
                if (categorie === "regime") {
                  composante["regimeId"] = id
                }
                if (categorie === "texture") {
                  composante["textureId"] = id
                }
              }
            })
          })
        resolve(this.plan.services)
      }).then(result => {
        this.plan.services = []
        this.$set(this.plan, "services", result)
        return
      })
    },
    titreService(serviceId) {
      return this.optionsTypesServices.find(opt => opt.value === serviceId).text
    },
    titreComposante(composante) {
      let titre = this.optionsComposantesRepas.find(
        opt => opt.value === composante.composanteId
      ).text
      if (composante.index && composante.index !== 0) {
        titre += " " + (composante.index + 1)
      }
      //titre += "-" + composante.regimeId + "-" + composante.textureId
      return titre
    },
    dupliquerComposante(serviceId, composanteTypeId) {
      let services = this.plan.services.filter(
        service => service.serviceId === serviceId
      )
      services.forEach(service => {
        let indexGeneral = service.planComposantes.length - 1 - service.planComposantes.reverse().findIndex(
          composante => composante.composanteId === composanteTypeId
        )
        let planComposantes = service.planComposantes.reverse().filter(
          composante => composante.composanteId === composanteTypeId
        )
        let newCompo = { ...planComposantes[planComposantes.length - 1] }
        newCompo.id = -1
        newCompo.index++
        newCompo.cleComposee = newCompo.composanteId + "-" + newCompo.index
        if (planComposantes[planComposantes.length - 1].effectif || planComposantes[planComposantes.length - 1].effectif === 0) {
          newCompo.effectif = 0
        }
        service.planComposantes.splice(indexGeneral + 1, 0, newCompo)
        planComposantes.push(newCompo)
      })
    },
    /* dupliquerEffectifs(services, service) {
      services.forEach(s => {
        if (s.cleComposee && s.cleComposee !== service.cleComposee) {
          service.planComposantes.forEach((c, i) => {
            s.planComposantes[i].effectif = c.effectif
          })
        }
      })
    }, */
    planServices(serviceId) {
      let planServices = _.orderBy(this.plan.services.filter(el => el.serviceId === serviceId), ["jour"], ["asc"])
      _.move = function (array, fromIndex, toIndex) {
        array.splice(toIndex, 0, array.splice(fromIndex, 1)[0])
      }
      _.move(planServices, 0, 6)
      return planServices
    },
    toogleService(serviceId) {
      if (
        this.plan.services.filter(el => el.serviceId === serviceId).length !== 0
      ) {
        return !!this.planServices(serviceId).filter(
          s => s.planComposantes.length !== 0
        ).length
      }
    },
    effacerComposante(serviceId, composanteId, index) {
      // eslint-disable-next-line promise/avoid-new
      return new Promise(resolve => {
        this.plan.services.map(service => {
          if (service.serviceId === serviceId) {
            _.remove(service.planComposantes, function (el) {
              return el.composanteId === composanteId && el.index === index
            })
          }
        })
        resolve(this.plan.services)
      }).then(result => {
        this.plan.services = []
        this.$set(this.plan, "services", result)
        return
      })
    },
    serviceComposantesTitres(service) {
      if (!this.arrayEmpty(service)) {
        let ids = service.map(el =>
          el.planComposantes.map(el => el.composanteId)
        )[0] // todo : flat dans l'édition
        return ids.map(
          el =>
            this.$store.state.definitions.composantesRepas.find(
              item => item.value === el
            ).text
        )
      }
    },
    serviceComposantesIds(service) {
      if (!this.arrayEmpty(service)) {
        let ids = service.map(el =>
          el.planComposantes.map(el => el.composanteId)
        )[0] // todo : flat dans l'édition
        return ids.map(el =>
          this.$store.state.definitions.composantesRepas.find(
            item => item.value === el
          )
        )
      }
    },
    ajouterComposante(serviceId) {
      this.plan.services
        .filter(jourDeService => jourDeService.serviceId === serviceId)
        .map(service => {
          this.composantesSelectionnees.map(planComposante => {
            let effectif = (service.effectif || service.effectif === null) ? service.effectif : 0
            let sr = {}
            sr["effectif"] = effectif
            sr["index"] = 0
            sr["composanteId"] = planComposante
            sr["jourServiceId"] = service.jour
            if (this.plan.gestionParPlan) {
              sr["regimeId"] = this.plan.regimeId
              sr["textureId"] = this.plan.textureId
            } else {
              sr["regimeId"] = constantesId.regimeNormal
              sr["textureId"] = constantesId.textureNormale
            }
            service.planComposantes.push(sr)
          })
        })
      this.composantesSelectionnees = []
    },
    status(validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty
      }
    },
    modifierEffectifs() {
      this.$emit("modifier-effectifs", this.effectifsEnCours)
      this.hide()
    },
    exporter(structureId) {
      // this.$store.commit("uxHelpers/showSpinner")
      this.afficherAttente()
      return obtenirMenuStructure(structureId, true).then(reponse => {
        this.cacherAttente()
        lancerTelechargement(new Blob([reponse.data]), this.plan.nom + ".json")
        return
      })
    },
    async getPlanPourEdition(structureId, universelle) {
      const reponse = await obtenirMenuStructure(structureId)
      this.plan = reponse.data
      if (universelle !== undefined) {// nettoyage de la copie
        if (!this.plan.etablissementId) {
          // Seules les structures de menus universelles sont déclinables
          this.plan.menuStructureOrigineId = structureId
        }
        this.plan.nom += " (copie)"
        this.plan.estUniversel = universelle
        delete this.plan.id
        delete this.plan.dateCreation
        delete this.plan.dateModification
        this.plan.services.forEach(service => {
          delete service.id
          delete service.menuPlanId
          delete service.cleComposee
          delete service.decalageJour
          service.planComposantes.forEach(composante => {
            delete composante.id
            delete composante.cleComposee
          })
        })
      }
      
      

      this.optionsTypesServices.map(service => {
        let servicesPresents = this.plan.services.filter(
          el => el.serviceId === service.value
        )
        let composantePresentes = []
        servicesPresents.forEach(service => {
          service.planComposantes.forEach(composante => {
            var trouve = composantePresentes.find(
              x => x.cleComposee == composante.cleComposee
            )
            if (!trouve) {
              composantePresentes.push(composante)
            }
          })
        })
        this.optionsJours.map(jour => {
          let serviceActuel = this.plan.services.find(el => el.serviceId === service.value && el.jour === jour.id)

          //let serviceContenantToutesLesComposantes = longestArray(servicesPresents, 'planComposantes')
          if (serviceActuel) {
            // serviceContenantToutesLesComposantes.planComposantes.map(el => {
            composantePresentes.map(compo => {
              if (
                !serviceActuel.planComposantes.find(
                  t => t.cleComposee === compo.cleComposee
                )
              ) {
                // rajouter une composante vierge
                serviceActuel.planComposantes.push({
                  cleComposee: compo.cleComposee,
                  composanteId: compo.composanteId,
                  effectif: null,
                  id: -1,
                  index: compo.index,
                  jourServiceId: compo.jourServiceId,
                  regimeId: compo.regimeId,
                  textureId: compo.textureId
                })
              }
            })
          } else {
            let servicePresent = this.plan.services.find(
              el => el.serviceId === service.value &&
                el.planComposantes &&
                el.planComposantes.length
            )
            if (servicePresent) {
              let planComposantes = _.cloneDeep(servicePresent.planComposantes)
              if (servicePresent.serviceId === service.value)
                planComposantes.forEach(el => {
                  el.effectif = null
                  el.id = -1
                })
              this.plan.services.push({ effectif: null, serviceId: service.value, jour: jour.id, planComposantes: planComposantes })
            } else {
              this.plan.services.push({ effectif: null, serviceId: service.value, jour: jour.id, planComposantes: [] })
            }
          }
        })
      })
    },
    async desactiver(id) {
      let resultat = await this.alerteConfirmation("Désactiver la structure de menu", "Souhaitez-vous masquer définitivement cette structure de menu ?<br />Les menus saisis avec cette structure seront conservés.")
      if (resultat) {
        return desactiverMenuStructure(id)
          .then(() => {
            if (this.$route.name === "MenusPlansEdition") {
              this.$emit("finished")
            } else if (this.$route.name === "Menus") {
              this.montrerModalEdition = false
              this.$emit("structure-supprimee")
            }
            return
          })
      }
    },
    async supprimer(id) {
      let resultat = await this.alerteConfirmation("Supprimer la structure de menu", "Souhaitez-vous supprimer cette structure de menu ?<br />Vous perdrez tous les menus saisis avec cette structure.")
      if (resultat) {
        return supprimerMenuStructure(id)
          .then(() => {
            if (this.$route.name === "MenusPlansEdition") {
              this.$emit("finished")
            } else if (this.$route.name === "Menus") {
              this.montrerModalEdition = false
              this.$emit("structure-supprimee")
            }
            return
          })
      }
    },
    creerServiceJours() {
      // remplit dans this.plan la structure pour tout les services et tout les jours possibles. (si pas déjà présent)
      this.optionsTypesServices.map(service => {
        this.optionsJours.map(jour => {
          const dejaPresent = this.plan.services.find(
            x => x.serviceId == service.value && x.jour == jour.id
          )
          if (!dejaPresent) {
            this.plan.services.push({
              effectif: null,
              serviceId: service.value,
              jour: jour.id,
              planComposantes: []
            })
          }
        })
      })
    },
    initEffectifsJour(serviceId, jourId) {
      var effectifsJour = []
      this.planServices(serviceId).find(service => service.jour === jourId).planComposantes.forEach(composante => {
        var type = effectifsJour.find(e => e.regimeId === composante.regimeId && e.textureId === composante.textureId)
        if (!type) {
          effectifsJour.push({
            regimeId: composante.regimeId,
            textureId: composante.textureId,
            titre: (composante.regimeId === "RE3" &&  composante.textureId === "TE1") ? "Normal" : (this.optionsTypesRegimes.find(r => r.value === composante.regimeId).text + " / " + this.optionsTypesRegimes.find(t => t.value === composante.textureId).text),
            effectif: 0
          })
          type = effectifsJour.find(e => e.regimeId === composante.regimeId && e.textureId === composante.textureId)
        }
        if (type.effectif < composante.effectif) {
          type.effectif = composante.effectif
        }
      })
      this.effectifsJour = effectifsJour
      this.keyEffectifsJour += 1
    },
    // setEffectifsJour(serviceId, jourId) {
    //   this.planServices(serviceId).find(service => service.jour === jourId).planComposantes.forEach(composante => {
    //     composante.effectif = this.effectifsJour.find(e => e.regimeId === composante.regimeId && e.textureId === composante.textureId).effectif || 0
    //   })
    //  this.plan.services.find(s => s.serviceId === serviceId && s.jour === jourId).effectif = this.effectifsJour.reduce((total, e) => total + e.effectif, 0)
    //  this.$bvModal.hide('changerEffectif-' + serviceId + '-' + jourId)
    // },
    enregistrerBarquettes(dataBarquettes) {
      this.plan.barquettes = []
      dataBarquettes.forEach(b => {
        this.plan.barquettes.push(this.listeBarquettes.filter(x => x.id === b.Id).first())
      })

      /*var data = this.plan.donneesSupplementaires && JSON.parse(this.plan.donneesSupplementaires.replaceAll("'", "\"")) || {}
      data.Barquettage = dataBarquettes
      this.plan.donneesSupplementaires = JSON.stringify(data).replaceAll("\"", "'")*/
      
    },
    async toggleFacturables() {
      if (!this.montrerFacturables) {//préparation des données
        this.facturables = this.plan.donneesSupplementaires && JSON.parse(this.plan.donneesSupplementaires.replaceAll("'", "\""))
        this.facturables = this.facturables && this.facturables.Facturables || []
        this.facturablesAvant = JSON.stringify(this.dataFacturables)
        this.checkFacturables()
        this.keyFacturables += 1
        this.montrerFacturables = true
      } else {
        if (!this.erreurFacturables) {//pas de fermeture en cas d'erreur
          if (this.modifFacturables) {
            let result = await this.alerteConfirmation('Modifications non enregistrées', "Les modifications effectuées sur les effectifs de facturation n'ont pas été appliquées.<br/>Voulez-vous les enregistrer ?")
            if (result) {
              return this.enregistrerFacturables()
            }
          }
          this.montrerFacturables = false
        }
      }
    },
    inputFacturable() {
      this.checkFacturables()
    },
    creerFacturable() {
      this.facturables.push({Id: "", Libelle: ""})
      this.checkFacturables()
      this.keyFacturables += 1
    },
    supprimerFacturable(index) {
      _.remove(this.facturables, (b, i) => i === index)
      this.checkFacturables()
      this.keyFacturables += 1
    },
    checkFacturable(facturable) {
      if (facturable.Libelle.length > 20) {
        facturable.Libelle = facturable.Libelle.substr(0, 20)
      }
      facturable.idValide = Boolean(facturable.Id)
      facturable.libelleValide = Boolean(facturable.Libelle)
    },
    checkFacturables() {
      this.facturables.forEach(this.checkFacturable)
      this.erreurFacturables = this.facturables.filter(b => !b.idValide || !b.libelleValide).length > 0
    },
    enregistrerFacturables() {
      var data = this.plan.donneesSupplementaires && JSON.parse(this.plan.donneesSupplementaires.replaceAll("'", "\"")) || {}
      data.Facturables = this.dataFacturables
      this.plan.donneesSupplementaires = JSON.stringify(data).replaceAll("\"", "'")
      this.montrerFacturables = false
    },
    clickOutFacturables(e) {//fermeture du combo par clic en dehors
      if (this.montrerFacturables && !e.target.closest("#facturables") && !e.target.closest(".swal2-container")) {
        this.toggleFacturables()
      }
    },
    moveEffectif(e, services, iService) {
      if (e.direction === "left" && iService > 0) {
        iService -= 1
      } else if ((e.direction === "right" || e.direction === "enter") && iService < services.length - 1) {
        iService += 1
      }
      let cible = services[iService].serviceId + "-" + services[iService].jour
      cible = this.$refs.effectifs.querySelector("[data-key='" + cible + "']")
      if (cible) {
        cible.focus()
      }
    },
    moveEffectifComposante(e, services, iService, iComposante) {
      if (e.direction === "left" && iService > 0) {
        iService -= 1
      } else if ((e.direction === "right" || e.direction === "enter") && iService < services.length - 1) {
        iService += 1
      } else if (e.direction === "up" && iComposante > 0) {
        iComposante -= 1
      } else if (e.direction === "down" && iComposante < services[iService].planComposantes.length - 1) {
        iComposante += 1
      }
      let cible = services[iService].serviceId + "-" + services[iService].jour + '-' + services[iService].planComposantes[iComposante].cleComposee
      cible = this.$refs.effectifs.querySelector("[data-key='" + cible + "']")
      if (cible) {
        cible.focus()
      }
    },
    onClose() {
      window.removeEventListener("click", this.clickOutFacturables)
      this.$emit("reset-select-plan")
    }
  },
  mounted() {
    this.filtres.initialiser(this)
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/couleurs.scss";
/* input, button, select, optgroup, textarea {
  width: 100% !important;
} */
.input-plan-composante {
  padding: 0.6rem 0;
}

.container-dupliquer-effacer {
  padding: 0;
  height: 3.21rem;
}
.inline-dropdown {
  width: 70px !important;
}
.ligne-composante-titre {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3.21rem;
}
.td-input-container {
  width: 60px;
}
.td-height {
  height: 3.21rem;
}
.table th,
.table td {
  border-bottom: none !important;
}
#facturables {
  position: absolute;
  z-index: 2;
  background: white;
  border: 1px solid black;
  border-radius: 3.5px;
  padding: 8px;
}
#facturables td.erreur {
  border: 1px solid red;
}
.btn-changer-eff {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.21rem;
}
</style>
